import catalog from "../data/reciters.json";

export type CatalogReciter = {
  id: string;
  name: string;
  baseUrl?: string;
  format?: string;      // e.g., "mp3"
  pattern?: string;     // e.g., "surah{num3}.mp3" or "{num3}.mp3"
  surahs?: Array<{ number: number; name: string; url?: string }>;
};

export function getCatalog() {
  return catalog as CatalogReciter[];
}

export function findReciter(reciterId: string) {
  return getCatalog().find(r => r.id === reciterId);
}

export function pad3(n: number) {
  return n.toString().padStart(3, "0");
}

function applyPattern(pattern: string, n: number) {
  return pattern
    .replace(/\{num3\}/g, pad3(n))
    .replace(/\{num\}/g, String(n));
}

export function getSurahAudioUrl(reciterId: string, surahNumber: number): string | null {
  const reciter = findReciter(reciterId);
  if (!reciter) return null;

  // 1) explicit URL
  const explicit = reciter.surahs?.find(s => s.number === surahNumber)?.url;
  if (explicit) return explicit;

  // 2) pattern
  if (reciter.baseUrl && reciter.pattern) {
    const base = reciter.baseUrl.replace(/\/+$/, "");
    return `${base}/${applyPattern(reciter.pattern, surahNumber)}`;
  }

  // 3) fallback: baseUrl + 3-digit + .format (default mp3)
  if (reciter.baseUrl) {
    const base = reciter.baseUrl.replace(/\/+$/, "");
    const ext = (reciter.format || "mp3").replace(/^\./, "");
    return `${base}/${pad3(surahNumber)}.${ext}`;
  }

  return null;
}

export function getReciterName(reciterId: string) {
  return findReciter(reciterId)?.name ?? reciterId;
}

export function getSurahNameFromCatalog(n: number) {
  for (const r of getCatalog()) {
    const s = r.surahs?.find(x => x.number === n);
    if (s?.name) return s.name;
  }
  return null;
}
